import React from "react";
import Typography from "@mui/material/Typography";
import CheckBoxField from "shared/form/CheckBoxField";
import BoxContent from "shared/ui/BoxContent";
import Loading from "shared/ui/Loading";
import StandardCategoriesListing from "../components/StandardsCategoriesListing";
import BacEvaluateCategoriesListing from "../components/BacEvaluateCategoriesListing";
import {TestType} from "../../../../shared/types/testTypes";
import SchoolTrainingCategoriesListing from "../components/SchoolTrainingCategoriesListing";
import {MAX_SELECTED_STANDARDS} from "../utils/functions";

const Title = ({type} : {type: TestType}) => (
    <>
        <Typography variant="h3" mb={3} mt={3}>
            Alege capitolele
        </Typography>

        {type === "school" && (
            <Typography variant="body1" mb={3}>
                Durata testului va varia în funcție de capitolele selectate. Timpul de rezolvare alocat
                acestuia va fi cuprins între <b>45 și 120</b> de minute.
            </Typography>
        )}

        {type === "training" && (
            <Typography variant="body1" mb={3}>
                Durata testului va varia în funcție de capitolele si numărul de itemi selectați. Timpul de
                rezolvare alocat acestuia va fi cuprins între <b>15 și 120</b> de minute.
            </Typography>
        )}

        {type === "literacy" && (
            <Typography variant="body1" mb={3}>
                Timpul maxim alocat testului de literație este de 60 de minute. După expirarea timpului,
                sesiunea se va închide automat.
            </Typography>
        )}

        {type === "digitalLiteracy" && (
            <Typography variant="body1" mb={3}>
                Timpul alocat testului de literație digitală este de minimum 40 de minute și maximum 4 ore
                și 20 minute, în funcție de numărul capitolelor alese. După expirarea timpului, sesiunea se
                va închide automat.
            </Typography>
        )}

        {type === "scientificLiteracy" && (
            <Typography variant="body1" mb={3}>
                Timpul alocat testului de literație științifică este de minimum 20 de minute și maximum 45
                de minute, în funcție de numărul capitolelor alese. După expirarea timpului, sesiunea se va
                închide automat.
            </Typography>
        )}

        {(type === "bac" || type === "evaluate") && (
            <Typography variant="body1" mb={3}>
                Sesiunea de testare va dura până la maximum 180 de minute.
            </Typography>
        )}
    </>
)

const Categories = ({
                        type,
                        loading,
                        errors,
                        categories,
                        grade,
                        variant,
                        setSelectedCategoriesHandler,
                        setSelectedVariant,
                        setSelectedStandardsHandler,
                    }: any) => {

    if(loading.loading && loading.name === "categories") {
        return (
            <>
                <Title type={type}/>
                <BoxContent><Loading show={true}/></BoxContent>
            </>
        )
    }

    const renderContent = () => {
        switch (type) {
            case "bac":
            case "evaluate":
                return (
                    <BoxContent>
                        <BacEvaluateCategoriesListing
                            erors={errors}
                            categories={categories}
                            variant={variant}
                            setSelectedCategoriesHandler={setSelectedCategoriesHandler}
                            setSelectedVariant={setSelectedVariant}
                        />
                    </BoxContent>
                );
            case "digitalLiteracy":
            case "scientificLiteracy":
                return (
                    <BoxContent>
                        {categories.length === 0 ? (
                            <Typography>Nu sunt itemi pentru selecția curentă.</Typography>
                        ) : (
                            <CheckBoxField
                                name="chapters"
                                type="checkbox-group"
                                label="Alege capitolele"
                                labelPlacement="end"
                                options={categories.map((item: {
                                    name: string;
                                    id: string;
                                    [key: string]: any
                                }) => {
                                    return {
                                        label: item.name,
                                        value: item.id.toString(),
                                        checked: !!item.checked,
                                        ...item,
                                    };
                                })}
                                onChange={(e) => setSelectedCategoriesHandler(e)}
                            />
                        )}
                    </BoxContent>
                );
            case "school":
            case "training":
                return (
                    <>
                        {grade <= 8 ? (
                            <>
                                <Typography>
                                    Selectează până la maximum {MAX_SELECTED_STANDARDS} standarde pe care vrei să le evaluezi în test.
                                </Typography>
                                <StandardCategoriesListing
                                    categories={categories}
                                    setSelectedStandardsHandler={setSelectedStandardsHandler}
                                />
                            </>
                        ) : (
                            <BoxContent>
                                <SchoolTrainingCategoriesListing
                                    categories={categories}
                                    type={type}
                                    setSelectedCategoriesHandler={setSelectedCategoriesHandler}
                                />
                            </BoxContent>
                        )}
                    </>
                );
                case "literacy":
                    return (
                        <BoxContent>
                            <SchoolTrainingCategoriesListing
                                categories={categories}
                                type={type}
                                setSelectedCategoriesHandler={setSelectedCategoriesHandler}
                            />
                        </BoxContent>
                    );
            default:
                return null;
        }
    }

    return (
        <>
            <Title type={type}/>
            {renderContent()}
        </>
    );
};

export default Categories;
